import { useState } from 'react';
import { NavBar } from '../../components/navBar.tsx';
import { PageTitle } from '../../components/pageTitle.tsx';
import { trpc } from '../../utils/trpc/trpc.ts';
import { PartNameInput } from './partNameInput.tsx';
import { PartNameResults } from './partNameResult.tsx';
import { SpcTable } from './spcTable.tsx';


export function SpcList() {

    const [partName, setPartName] = useState('');

    const { data: spcStates, error, isLoading } = trpc.spc.getCurrentState.useQuery(
        undefined,
        { refetchOnWindowFocus: false, }
    );


    return (
        <>
            <PageTitle title='Spc' />
            <NavBar />
            <div className='content' style={{ maxWidth: '1280px' }}>
                {/* <h2>Part number search</h2> */}
                <PartNameInput
                    partName={partName}
                    setPartName={setPartName}
                />

                {partName && <>
                    <h2>Search results</h2>
                    <PartNameResults partName={partName} />
                </>}

                {!partName && <>
                    <h2>Current batches</h2>
                    {isLoading && <div>Loading...</div>}
                    {error && <div>Error: {error.message}</div>}
                    {spcStates && <SpcTable spcStates={spcStates} />}
                </>}
            </div>
        </>
    );
}
